import { ReleaseContract } from '../../contract/release.contract';

export const GET_RELEASES: ReleaseContract[] = [
  {
    name: 'Release v5.0.0',
    tagName: 'v5.0.0',
    releasedAt: '2026-09-07T10:00:00.000Z',
    descriptionHtml: `
<h2>Nieuwe functies en verbeteringen</h2>
<p>In deze release hebben we een aantal grote verbeteringen doorgevoerd die het plannen en beheren van begeleiders nog makkelijker maken.</p>

<h3>Shifts verplaatsen naar een andere dag</h3>
<p>Het is nu mogelijk om een shift eenvoudig te verplaatsen naar een andere dag. In het bewerkingsscherm van een shift kun je nu ook de datum aanpassen.</p>

<h3>Standplaats voor begeleiders</h3>
<p>We hebben het concept van 'standplaats' geïntroduceerd. We kunnen nu beter aangeven op welke specifieke locatie een begeleider werkt. Of juist in een sub regio. Dit is direct zichtbaar op de nieuwe begeleiderskaart.</p>

<h3>Certificaten voortgang</h3>
<p>De voortgang van certificaten is nu visueel inzichtelijk op de documentenpagina van de begeleider. Zo zie je direct hoe ver een begeleider is in lyceo Academie.</p>

<h3>Verbeterde downloads</h3>
<p>Het downloaden van lesmateriaal en documenten is volledig vernieuwd. Documenten openen nu direct in een nieuw tabblad en de downloads zijn stabieler geworden door het gebruik van beveiligde links.</p>

<h3>Ziekte-waarschuwingen</h3>
<p>Op de begeleiderskaart tonen we nu een duidelijke waarschuwing als een begeleider vandaag als ziek staat geregistreerd, zodat je hier bij het plannen direct rekening mee kunt houden.</p>
    `,
    images: [],
  },
  {
    name: 'Prestatie-verbeteringen',
    tagName: 'prestatie-verbeteringen',
    releasedAt: '2026-04-16T12:00:00.000Z',
    descriptionHtml: `
<h2>Prestatie-verbeteringen</h2>
<p>
  In deze release zijn meerdere prestatieverbeteringen doorgevoerd om de applicatie efficiënter te laten functioneren.
  Hiermee zijn onderliggende processen geoptimaliseerd, wat in veel gevallen zorgt voor een vlottere werking en een betere
  responsiviteit.
</p>
    `,
    images: [],
  },
  {
    name: 'Release v4.0.0',
    tagName: 'v4.0.0',
    releasedAt: '2025-07-24T12:00:00.000Z',
    descriptionHtml: `
<h2>De nieuwe roostertool is er!</h2>
<p>Tadaaa! Na ruim 1,5 jaar hard werken, zweten en (soms) een traantje wegpinken, presenteren we
met trots onze compleet vernieuwde roostertool! We hebben geluisterd naar jullie feedback, wensen
en zelfs die kleine ergernissen die jullie nooit hardop durfden uit te spreken 😉.
Het resultaat mag er zijn: een snellere, slimmere en gebruiksvriendelijkere tool die jullie
dagelijks werk een stuk aangenamer maakt.</p>
<h3>Nieuwe zoekfunctie voor vestigingsmanagers</h3>
<p>De zoekfunctie is nu ook beschikbaar gemaakt voor vestigingsmanagers. Hierdoor kun je snel en
eenvoudig leerlingen en begeleiders vinden, net zoals het roosterteam dat al kon.</p>
<h3>Begeleiders-pagina nu ook voor vestigingsmanagers</h3>
<p>Vestigingsmanagers hebben nu toegang tot de begeleiders-pagina.
Hierdoor krijg je direct inzicht in de details van je begeleider.</p>
<h3>Bijhouden of iemand benaderd is voor een opdracht</h3>
<p>Vanaf nu kun je bijhouden of een begeleider al benaderd is voor een opdracht
 Zo voorkom je dat begeleiders per ongeluk dubbel of te vaak worden benaderd.</p>
<h3>Verbeterde snelheid</h3>
<p>We hebben onder de motorkap hard gewerkt aan prestatieverbeteringen. Het systeem werkt nu
aanzienlijk sneller, waardoor jij nog efficiënter kunt roosteren.</p>
    `,
    images: [
      { name: 'Zoeken pagina', url: './assets/img/releases/4.0-search.png' },
      {
        name: 'Begeleiders-pagina',
        url: './assets/img/releases/4.0-begeleiders.png',
      },
      {
        name: 'benaderde begeleider',
        url: './assets/img/releases/4.0-benaderen.png',
      },
    ],
  },
  {
    name: 'Release v3.2.0',
    tagName: 'v3.2.0',
    releasedAt: '2023-08-23T10:00:00.000Z',
    descriptionHtml: `
<h2>Nieuwe overzichten - wachtend op shift</h2>
<p>
  We hebben 2 nieuwe overzichten geïntroduceerd om een beter beeld te geven
  over welke leerlingen op dit moment in afwachting zijn van een shift:
  <ul>
    <li>Het eerste overzicht toont leerlingen die nog wachten op hun allereerste shift.</li>
    <li>Het tweede overzicht geeft een overzicht van leerlingen die in afwachting zijn van een vervolg-shift.</li>
  </ul>
  Deze overzichten kun je vinden via het hoofdmenu aan de zijkant. Op het dashboard is daarnaast een nieuw
  blokje toegevoegd met het aantal leerlingen dat wacht op een eerste shift.
</p>
<h2>Opmerking toevoegen bij begeleider</h2>
<p>
  We hebben nu de optie toegevoegd om opmerkingen toe te voegen bij begeleiders.
  Deze handige feature is beschikbaar via het begeleider-overzicht en maakt het
  opslaan van relevante informatie over begeleiders eenvoudiger.
</p>
<p>
  Belangrijk detail: opmerkingen die via de roostertool worden toegevoegd,
  kunnen niet achteraf via de roostertool worden bijgewerkt of verwijderd. Dit
  kan alleen via het personeelsadministratie-systeem (Perza).
</p>
<h2>Verbeterde weergave beschikbaarheid begeleider</h2>
<p>
  Het beschikbaarheidsoverzicht van een begeleider is geüpdatet. Het nieuwe ontwerp is niet
  alleen overzichtelijker, maar het biedt ook een verbeterde gebruikerservaring. Nu kun je
  gemakkelijk wisselen tussen verschillende maanden. Bovendien hebben we een handige dagweergave toegevoegd,
  zodat je ook gedetailleerde beschikbaarheidsinformatie per dag kunt zien.
</p>
    `,
    images: [
      { name: 'Wachtend op shift', url: './assets/img/releases/3.2.0-awaiting-slots.png' },
      {
        name: 'Opmerkingen begeleider',
        url: './assets/img/releases/3.2.0-candidate-remarks.png',
      },
      {
        name: 'Beschikbaarheid begeleider',
        url: './assets/img/releases/3.2.0-candidate-availability.png',
      },
    ],
  },
  {
    name: 'Release v3.0.0',
    tagName: 'v3.0.0',
    releasedAt: '2023-02-13T14:00:00.000Z',

    descriptionHtml: `
<h2>Nieuwe layout</h2>
<p>
  De afgelopen maanden heeft het IT-team hard gewerkt om de roostertool een complete metamorfose te geven.
  Hij ziet er niet alleen een stuk mooier uit, maar werkt ook een stuk sneller en efficiënter.
  Een groot deel van de gebruikers heeft deze nieuwe versie al uitgeprobeerd in de beta-omgeving.
  Nu is het tijd om de 'oude' roostertool vaarwel te zeggen!
</p>
<br>
<h3>Nieuwe functionaliteiten</h3>
<ul>
  <li>
    Wanneer je een begeleider uitroostert van een opdracht (of een shift verwijdert uit een opdracht),
    word je gevraagd om hiervoor een reden op te geven.
  </li>
  <li>Overnachtingsaddressen van de begeleiders zijn nu zichtbaar in het kandidaatscherm.</li>
  <li> In het opdrachtdialoog kun je in de tab 'historie' zien wanneer en door wie een
  opdracht is ingepland, bevestigd, goedgekeurd etc. </li>
  <li> 'Oude' locaties zijn in principe niet meer zichtbaar in de roostertool. Alleen leden
   van het roosterteam kunnen oude locaties nog inzien, wanneer zij hier specifiek op zoeken op de zoekpagina.
   </li>
 </ul>
 <p><strong>PS:</strong> De beta-omgeving blijft bestaan. Hierin zullen nieuwe functionaliteiten als eerste beschikbaar
 komen.
 Dus wil je graag als eerste genieten van de nieuwste features én het IT team helpen met jouw feedback, blijf dan
 vooral gebruikmaken van de beta versie!</p>
`,
    images: [
      {
        name: 'New UI',
        url: './assets/img/releases/3.0.0-new-shifts.png',
      },
    ],
  },
  {
    name: 'Release v3.0.0-RC.4',
    tagName: 'v3.0.0-RC.4',
    releasedAt: '2023-02-07T13:00:00.000Z',

    descriptionHtml: `
<h2>Nieuw ontwerp voor shifts</h2>
<p>
    Op verzoek is er nog een keer gekeken naar de weergave van shifts.
    <br />Dit hebben we natuurlijk meteen voor jullie opgepakt!
</p>
<br />
<h3>Opgeloste bugs</h3>
<ul>
  <li>
    Nadat je voor de tweede keer iemand had ingepland, bleef de lijst met kandidaten
    <br />leeg. Dit is nu opgelost.
  </li>
  <li>Soms bleef de applicatie hangen als er meerdere shifts geselecteerd waren.<br /> Dit is nu opgelost.</li>
  <li>Shifts waar al iemand op ingepland is, kun je nu niet meer aanklikken bij het <br /> selecteren van shifts.</li>
  <li>Als je van week wisselde, waren de shifts allemaal rood. Nu niet meer.</li>
</ul>
`,
    images: [
      {
        name: 'New UI',
        url: './assets/img/releases/3.0.0-new-shifts.png',
      },
    ],
  },
  {
    name: 'Release v3.0.0-RC.3',
    tagName: 'v3.0.0-RC.3',
    releasedAt: '2023-01-18T15:00:00.000Z',

    descriptionHtml: `
    <h2>Bugfixes</h2>
<p>Een aantal van de bugs waar mensen tegen aanliepen zijn gefixt met deze release.</p>
<br>
<h3>Opgeloste bugs</h3>
<ul>
    <li>Inplannen van meerder shifts tegelijk</li>
    <li>Vestigingsmanagers kunnen nu ook het WhatsApp-icoontje gebruiken</li>
    <li>Opdrachtpreview klopt weer met wat geselecteerd is</li>
    <li>'Sorteer volgorde' in de week-weergave is verbeterd</li>
    <li>Kandidatenlijst verspringt soms</li>
    <li>Flikkerende mouseover bij shifts</li>
</ul>
`,
    images: [
      {
        name: 'New UI',
        url: './assets/img/releases/3.0.0-new-ui.png',
      },
    ],
  },
];
